<form [formGroup]="searchForm" (ngSubmit)="onSearchClick()" autocomplete="off">
  <div class="form-group">
    <div class="input-group">
      <div class="input-group-prepend">
        <button class="btn btn-outline-danger" type="button" id="button-clear" (click)="onSearchClearClick()">
          <fa-icon [icon]="faClose"></fa-icon>
        </button>
      </div>
      <input #search autocomplete="false" id="search-input" type="text" class="form-control" formControlName="query"
        (ngModelChange)="onSearchChange()" aria-describedby="search-button"/>

      @if (!autoSearch) {
        <div class="input-group-append">
          <button class="btn btn-primary" type="submit" id="button-search"
            [disabled]="search.value.length < minCharacter">
            Search
          </button>
        </div>
      }
    </div>
  </div>
</form>

